import {
  createErrorType,
  createSubmitType,
  createSuccessType,
  createLoadingType,
  createUpdateType,
  createDeleteType,
} from '../actionHelpers';

const CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_SCOPE =
  'CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_SCOPE';
export const CREATE_IRA_APPLICATION_ACCOUNT_NUMBER = createSubmitType(
  CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_SCOPE,
);
export const CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_SUCCESS = createSuccessType(
  CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_SCOPE,
);
export const CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_ERROR = createErrorType(
  CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_SCOPE,
);
export const CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_LOADING = createLoadingType(
  CREATE_IRA_APPLICATION_ACCOUNT_NUMBER_SCOPE,
);

const UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_SCOPE =
  'UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_SCOPE';
export const UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER = createUpdateType(
  UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_SCOPE,
);
export const UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_SUCCESS = createSuccessType(
  UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_SCOPE,
);
export const UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_ERROR = createErrorType(
  UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_SCOPE,
);
export const UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_LOADING = createLoadingType(
  UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER_SCOPE,
);

const CREATE_IRA_APPLICATION_FUNDING_AMOUNT_SCOPE =
  'CREATE_IRA_APPLICATION_FUNDING_AMOUNT_SCOPE';
export const CREATE_IRA_APPLICATION_FUNDING_AMOUNT = createSubmitType(
  CREATE_IRA_APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const CREATE_IRA_APPLICATION_FUNDING_AMOUNT_SUCCESS = createSuccessType(
  CREATE_IRA_APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const CREATE_IRA_APPLICATION_FUNDING_AMOUNT_ERROR = createErrorType(
  CREATE_IRA_APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const CREATE_IRA_APPLICATION_FUNDING_AMOUNT_LOADING = createLoadingType(
  CREATE_IRA_APPLICATION_FUNDING_AMOUNT_SCOPE,
);

const UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_SCOPE =
  'UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_SCOPE';
export const UPDATE_IRA_APPLICATION_FUNDING_AMOUNT = createUpdateType(
  UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_SUCCESS = createSuccessType(
  UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_ERROR = createErrorType(
  UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_SCOPE,
);
export const UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_LOADING = createLoadingType(
  UPDATE_IRA_APPLICATION_FUNDING_AMOUNT_SCOPE,
);

const CREATE_IRA_APPLICATION_TRANSFER_TYPE_SCOPE =
  'CREATE_IRA_APPLICATION_TRANSFER_TYPE_SCOPE';
export const CREATE_IRA_APPLICATION_TRANSFER_TYPE = createSubmitType(
  CREATE_IRA_APPLICATION_TRANSFER_TYPE_SCOPE,
);
export const CREATE_IRA_APPLICATION_TRANSFER_TYPE_SUCCESS = createSuccessType(
  CREATE_IRA_APPLICATION_TRANSFER_TYPE_SCOPE,
);
export const CREATE_IRA_APPLICATION_TRANSFER_TYPE_ERROR = createErrorType(
  CREATE_IRA_APPLICATION_TRANSFER_TYPE_SCOPE,
);
export const CREATE_IRA_APPLICATION_TRANSFER_TYPE_LOADING = createLoadingType(
  CREATE_IRA_APPLICATION_TRANSFER_TYPE_SCOPE,
);

const UPDATE_IRA_APPLICATION_TRANSFER_TYPE_SCOPE =
  'UPDATE_IRA_APPLICATION_TRANSFER_TYPE_SCOPE';
export const UPDATE_IRA_APPLICATION_TRANSFER_TYPE = createUpdateType(
  UPDATE_IRA_APPLICATION_TRANSFER_TYPE_SCOPE,
);
export const UPDATE_IRA_APPLICATION_TRANSFER_TYPE_SUCCESS = createSuccessType(
  UPDATE_IRA_APPLICATION_TRANSFER_TYPE_SCOPE,
);
export const UPDATE_IRA_APPLICATION_TRANSFER_TYPE_ERROR = createErrorType(
  UPDATE_IRA_APPLICATION_TRANSFER_TYPE_SCOPE,
);
export const UPDATE_IRA_APPLICATION_TRANSFER_TYPE_LOADING = createLoadingType(
  UPDATE_IRA_APPLICATION_TRANSFER_TYPE_SCOPE,
);

const CREATE_IRA_APPLICATION_FUNDING_TYPE_SCOPE =
  'CREATE_IRA_APPLICATION_FUNDING_TYPE_SCOPE';
export const CREATE_IRA_APPLICATION_FUNDING_TYPE = createSubmitType(
  CREATE_IRA_APPLICATION_FUNDING_TYPE_SCOPE,
);
export const CREATE_IRA_APPLICATION_FUNDING_TYPE_SUCCESS = createSuccessType(
  CREATE_IRA_APPLICATION_FUNDING_TYPE_SCOPE,
);
export const CREATE_IRA_APPLICATION_FUNDING_TYPE_ERROR = createErrorType(
  CREATE_IRA_APPLICATION_FUNDING_TYPE_SCOPE,
);
export const CREATE_IRA_APPLICATION_FUNDING_TYPE_LOADING = createLoadingType(
  CREATE_IRA_APPLICATION_FUNDING_TYPE_SCOPE,
);

const UPDATE_IRA_APPLICATION_FUNDING_TYPE_SCOPE =
  'UPDATE_IRA_APPLICATION_FUNDING_TYPE_SCOPE';
export const UPDATE_IRA_APPLICATION_FUNDING_TYPE = createUpdateType(
  UPDATE_IRA_APPLICATION_FUNDING_TYPE_SCOPE,
);
export const UPDATE_IRA_APPLICATION_FUNDING_TYPE_SUCCESS = createSuccessType(
  UPDATE_IRA_APPLICATION_FUNDING_TYPE_SCOPE,
);
export const UPDATE_IRA_APPLICATION_FUNDING_TYPE_ERROR = createErrorType(
  UPDATE_IRA_APPLICATION_FUNDING_TYPE_SCOPE,
);
export const UPDATE_IRA_APPLICATION_FUNDING_TYPE_LOADING = createLoadingType(
  UPDATE_IRA_APPLICATION_FUNDING_TYPE_SCOPE,
);

const DELETE_IRA_APPLICATION_FUNDING_SCOPE =
  'DELETE_IRA_APPLICATION_FUNDING_SCOPE';
export const DELETE_IRA_APPLICATION_FUNDING = createDeleteType(
  DELETE_IRA_APPLICATION_FUNDING_SCOPE,
);
export const DELETE_IRA_APPLICATION_FUNDING_SUCCESS = createSuccessType(
  DELETE_IRA_APPLICATION_FUNDING_SCOPE,
);
export const DELETE_IRA_APPLICATION_FUNDING_ERROR = createErrorType(
  DELETE_IRA_APPLICATION_FUNDING_SCOPE,
);
export const DELETE_IRA_APPLICATION_FUNDING_LOADING = createLoadingType(
  DELETE_IRA_APPLICATION_FUNDING_SCOPE,
);

const CREATE_IRA_APPLICATION_ACCOUNT_TYPE_SCOPE =
  'CREATE_IRA_APPLICATION_ACCOUNT_TYPE_SCOPE';
export const CREATE_IRA_APPLICATION_ACCOUNT_TYPE = createSubmitType(
  CREATE_IRA_APPLICATION_ACCOUNT_TYPE_SCOPE,
);
export const CREATE_IRA_APPLICATION_ACCOUNT_TYPE_SUCCESS = createSuccessType(
  CREATE_IRA_APPLICATION_ACCOUNT_TYPE_SCOPE,
);
export const CREATE_IRA_APPLICATION_ACCOUNT_TYPE_ERROR = createErrorType(
  CREATE_IRA_APPLICATION_ACCOUNT_TYPE_SCOPE,
);
export const CREATE_IRA_APPLICATION_ACCOUNT_TYPE_LOADING = createLoadingType(
  CREATE_IRA_APPLICATION_ACCOUNT_TYPE_SCOPE,
);

const UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_SCOPE =
  'UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_SCOPE';
export const UPDATE_IRA_APPLICATION_ACCOUNT_TYPE = createSubmitType(
  UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_SCOPE,
);
export const UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_SUCCESS = createSuccessType(
  UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_SCOPE,
);
export const UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_ERROR = createErrorType(
  UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_SCOPE,
);
export const UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_LOADING = createLoadingType(
  UPDATE_IRA_APPLICATION_ACCOUNT_TYPE_SCOPE,
);

const CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SCOPE =
  'CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE';
export const CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE = createSubmitType(
  CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SCOPE,
);
export const CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SUCCESS = createSuccessType(
  CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SCOPE,
);
export const CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_ERROR = createErrorType(
  CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SCOPE,
);
export const CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_LOADING = createLoadingType(
  CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SCOPE,
);

const UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SCOPE =
  'UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE';
export const UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE = createSubmitType(
  UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SCOPE,
);
export const UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SUCCESS = createSuccessType(
  UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SCOPE,
);
export const UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_ERROR = createErrorType(
  UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SCOPE,
);
export const UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_LOADING = createLoadingType(
  UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE_SCOPE,
);
